import ModalLayout from "components/modal/modal-layout/ModalLayout";
import messages from "messages";
import { Button } from "react-bootstrap";
import { ReactComponent as Background } from "./background.svg";
import styles from "./styles.module.scss";
import { AmplitudePageName, track } from "utils/amplitude";

type Props = {
  show: boolean;
  onHide: () => void;
  onNext: () => void;
  amplitudePageName: AmplitudePageName;
};

const AMPLITUDE_COMPONENT_NAME = "set-up-schedule-modal";

const GetStarted = ({ onNext, amplitudePageName, ...props }: Props) => (
  <ModalLayout
    {...props}
    autoFocus
    size={"xl"}
    bodyClass={styles["get-started__body"]}
    backdrop={"static"}
    keyboard={false}
  >
    <div className={styles["get-started__message"]}>
      {messages.weWillHelpYou}
    </div>
    <Button
      className={styles["get-started__btn"]}
      type={"button"}
      onClick={() => {
        track(
          amplitudePageName,
          [AMPLITUDE_COMPONENT_NAME, "get-started-button"],
          "click",
        );
        onNext();
      }}
    >
      {messages.getStarted}
    </Button>
    <Background className={styles["get-started__background"]} />
  </ModalLayout>
);

export default GetStarted;
